import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/rootReducer'

export const useIsIframeLimitedNavigation = () => {
  const iframeTopMenu = useSelector<IRootReducerState, boolean>(state => state.menu.iframeTopMenu)
  return iframeTopMenu
}
